import { render, staticRenderFns } from "./TopButton.vue?vue&type=template&id=81ec3c34"
import script from "./TopButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TopButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports